module.exports = __webpack_public_path__ + "img/video-subject-4.png";